import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';

interface TMobilePageTitleProps {
  currentPath: string;
}

const MobilePageTitle: FC<TMobilePageTitleProps> = ({ currentPath }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const getPageTitle = (path: string) => {
    switch (path) {
      case '/deliveries':
        return t('navigation.deliveries');
      case '/couriers':
        return t('navigation.couriers');
      case '/product-overview':
        return 'Product Overview'
      case '/courier-overview':
        return 'Courier Overview'
      case '/delivery-history':
        return 'Delivery History'
      default:
        return '';
    }
  };

  return <h2 className={classes.title}>{getPageTitle(currentPath)}</h2>;
};

export default MobilePageTitle;
